import React from 'react'
import ReactDOM from 'react-dom'

export const checkoutActionSpacerStyle: React.CSSProperties = {
    height: 118,
}

export const getCheckoutActionButtonStyle = (isMobile: boolean): React.CSSProperties => {
    
    if (isMobile) {
        return {
            position: 'fixed',
            
            left: 0,
            right: 0,
            bottom: 56,
            zIndex: 1100,
            width: '100%',
            boxSizing: 'border-box',
            marginTop: 0,
            padding: '12px 20px env(safe-area-inset-bottom, 0px)',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            backgroundColor: '#fff',
            boxShadow: '0px -2px 10px rgba(0,0,0,.12)',
        }
    }

    return {
        flexDirection: 'row',
        justifyContent: 'space-around',
        display: 'flex',
        padding: 20,
        width: '90%',
        marginTop: 20,
    }
}

type CheckoutActionButtonProps = {
    isMobile: boolean
    children: React.ReactNode
}

export const CheckoutActionButton = ({ isMobile, children }: CheckoutActionButtonProps) => {
    if (!isMobile) {
        return <div style={getCheckoutActionButtonStyle(false)}>{children}</div>
    }

    return <>
        <div style={checkoutActionSpacerStyle} />
        {ReactDOM.createPortal(
            <div style={getCheckoutActionButtonStyle(true)}>{children}</div>,
            document.body
        )}
    </>
}
